import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { linkBrandFavicon, resolveBrand } from "@/shared/brand";
import App from "./App";
import "@/shared/i18n/init";
import "@/index.css";

// Brand token cascade: onecareer is the default (:root block in figma.gen.css,
// no attribute). ChapterNext needs the data-brand attribute so its
// [data-brand="chapternext"] token block wins. Login stays light — no `.dark`.
// On failed resolution nothing is set, favicon included; App renders the
// error screen on the default tokens.
const brand = resolveBrand();
if (brand.ok && brand.brand === "chapternext") {
  document.documentElement.setAttribute("data-brand", "chapternext");
}
if (brand.ok) linkBrandFavicon(brand.brand);

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root element "#root" not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
